module.exports = __webpack_public_path__ + "static/img/p2.f7c9ae2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/p2.png
// module id = yZ/M
// module chunks = 1